module.exports = __webpack_public_path__ + "static/media/waffle.1e4436d1.png";